<template>
    <aside class="menu sidebar-menu slide-menu" :class="{ 'is-open': menuOpen }">
        <!-- Collapse button for mobile menu -->
        <button v-if="menuOpen" class="button is-small menu-collapse is-hidden-desktop" @click="menuOpen = false">
            <span class="icon"><i class="fas fa-times"></i></span>
        </button>

        <slot> </slot>
    </aside>
    <!-- Overlay for closing menu on mobile -->
    <div v-if="menuOpen" class="sidebar-menu menu-overlay is-hidden-desktop" @click="menuOpen = false"></div>
</template>

<script setup lang="ts">
    import { ref } from "vue";

    const menuOpen = ref(false);

    function openMenu() {
        menuOpen.value = true;
    }

    function hideMenu() {
        menuOpen.value = false;
    }

    defineExpose({ openMenu, hideMenu });
</script>

<style scoped></style>
